import { store } from '../../../store'
import { MessageDataType } from '../types'
import { unshiftTickAction } from '../../../store/orderbook/actions'
import { Tick } from '../../../store/orderbook/types'
import { OrderDirection } from '../../../store/spot/types'
import { Price, Quantity, SymbolName, Timestamp } from '../../../types'
import { v4 } from 'uuid'

export type WsTickDataItem = [
  Timestamp, // Millisecond timestamp, 1597026380000
  0 | 1, // Direction, 0: sell，1: buy
  Price, // Price, 40000.000000
  Quantity, // SPOTS: size, CONTRACTS: quantity, 1.000000
  number, // Volume of usd value, 4000.000000
  0, // Trade flag, 0: normal, Waiting the server to add liquidation and ADL and more flags
]

export interface WsTickData {
  type: 'tick'
  symbol: SymbolName
  data: WsTickDataItem[]
}

export function onMessageTick(data: MessageDataType) {
  switch (data.type) {
    // Receive all matching data for the current symbol, used to display in the 'Trade' component
    case 'tick':
      updateTick(data as WsTickData)
      break
  }
}

function parseTickData(data: WsTickData): Tick[] {
  return data.data.map((v) => {
    return {
      key: v4(),
      symbol: data.symbol,
      timestamp: v[0],
      direction: v[1] === 0 ? OrderDirection.SHORT : OrderDirection.LONG,
      price: v[2],
      quantity: v[3],
      volume: v[4],
      flag: v[5],
    }
  })
}

function updateTick(data: WsTickData) {
  const { symbol } = data

  store.dispatch(
    unshiftTickAction({
      symbolName: symbol,
      list: parseTickData(data),
    }),
  )
}
